import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { MONO } from "../constants"

export function MentionDropdown({ query, users, onSelect }) {
  const filtered = users
    .filter(u => !query || u.username.toLowerCase().startsWith(query.toLowerCase()) ||
      (u.display_name ?? "").toLowerCase().startsWith(query.toLowerCase()))
    .slice(0, 5)
  if (!filtered.length) return null
  return (
    <Box sx={{ position: "absolute", bottom: "100%", left: 8, right: 8,
      backgroundColor: "var(--app-paper)", border: "1px solid rgba(245,158,11,0.22)",
      borderRadius: "6px 6px 0 0", zIndex: 1400, overflow: "hidden" }}>
      {filtered.map(u => (
        <Box key={u.username} onClick={() => onSelect(u.username)}
          sx={{ display: "flex", alignItems: "center", gap: 1, px: 1.25, py: 0.6,
            cursor: "pointer", "&:hover": { backgroundColor: "rgba(245,158,11,0.07)" } }}>
          <Box sx={{ width: 5, height: 5, borderRadius: "50%",
            backgroundColor: u.online ? "var(--app-success)" : "rgba(var(--app-fg-rgb),0.2)", flexShrink: 0 }} />
          <Typography sx={{ fontFamily: MONO, fontSize: "0.67rem", color: "rgba(var(--app-fg-rgb),0.8)" }}>
            {u.display_name ?? u.username}
          </Typography>
          <Typography sx={{ fontFamily: MONO, fontSize: "0.6rem", color: "rgba(var(--app-fg-rgb),0.3)" }}>
            @{u.username}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}
